import { useCallback, useRef } from 'react'

const useInfinitScroll = (loading, remaining, nextOffset, setPagination, dependencyArray) => {
  const observer = useRef()
  return useCallback(
    (node) => {
      if (loading) {
        return
      }
      if (observer.current) {
        observer.current.disconnect()
      }
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && remaining > 0) {
          setPagination({ nextOffset: nextOffset, isPagination: true })
        }
      })
      if (node) {
        observer.current.observe(node)
      }
    },
    [...dependencyArray]
  )
}

export default useInfinitScroll
